(function () {
  var STORAGE_KEY = 'gf_breadcrumb_back';
  function save(entry) {
    try { sessionStorage.setItem(STORAGE_KEY, JSON.stringify(entry)); } catch (e) {}
  }
  function load() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (e) { return null; }
  }
  var template = window.__gfBreadcrumbTemplate;
  var data = window.__gfBreadcrumbData || {};
  if (template === 'collection' || template === 'search') {
    if (data.url && data.title) { save({ url: data.url, title: data.title }); }
    return;
  }
  if (template === 'product') {
    var back = load();
    var item = document.getElementById('gf-breadcrumb-back-item');
    var link = document.getElementById('gf-breadcrumb-back-link');
    var text = document.getElementById('gf-breadcrumb-back-text');
    if (!item || !link || !text) { return; }
    if (back && back.url && back.title) {
      link.setAttribute('href', back.url);
      text.textContent = back.title;
      item.style.display = '';
    } else if (!link.getAttribute('href')) {
      item.style.display = 'none';
    }
  }
})();
